import { Button, Card, CardContent, CardTitle } from '@e2n/ui/v2';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function FeiertagskontoActive({
  handleChange,
}: {
  handleChange: () => Promise<void>;
}) {
  const { t } = useTranslation();
  return (
    <Card className="w-full">
      <CardContent className="gap-4">
        <div className="hidden md:block">
          <div className="flex justify-between items-center flex-row">
            <CardTitle className="font-normal text-sm">
              <FontAwesomeIcon
                icon={faCheck}
                size="lg"
                className="pr-2 to-brand-blue-100"
              />
              {t('domain.mitarbeiter.feiertagskonto.isActive.titel')}
            </CardTitle>
            <Button
              variant="outline"
              onClick={() => {
                handleChange();
              }}>
              {t('domain.mitarbeiter.feiertagskonto.isActive.buttonLabel')}
            </Button>
          </div>
        </div>
        <div className="md:hidden">
          <div className="gap-4 flex flex-col justify-between">
            <CardTitle className="font-normal text-sm flex">
              <FontAwesomeIcon
                icon={faCheck}
                size="lg"
                className="pr-2 to-brand-blue-100"
              />
              <div>{t('domain.mitarbeiter.feiertagskonto.isActive.titel')}</div>
            </CardTitle>
            <Button
              variant="outline"
              className="md:hidden w-full"
              onClick={() => {
                handleChange();
              }}>
              {t('domain.mitarbeiter.feiertagskonto.isActive.buttonLabel')}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
